<ng-container *ngIf="data$ | async as data">
  <mat-card>
    <mat-card-content>
      <mat-sidenav-container [hasBackdrop]="false" (clickOutside)="sidenav.close()">
        <mat-sidenav
          class="sidebar"
          role="region"
          #sidenav
          [position]="'end'"
          [mode]="'over'"
          [fixedInViewport]="true"
          [fixedTopGap]="getSideNavTopGap()"
        >
          <local-seo-listing-sidebar
            #listingSidebar
            (closed)="sidenav.close()"
            [data]="data"
          ></local-seo-listing-sidebar>
        </mat-sidenav>
        <mat-sidenav-content (click)="this.open(data?.locked)">
          <div class="card-title" [ngClass]="{ greyscale: data?.locked }">
            <local-seo-source-name-icon
              [ngClass]="{ faded: data.locked }"
              [name]="data?.name"
              [iconUrl]="data?.sourceIcon"
              [ecosystemSources]="data?.ecosystemSources?.length"
            ></local-seo-source-name-icon>
            <div>{{ data?.name }}</div>
            <mat-icon *ngIf="data.locked" class="lock">lock</mat-icon>
          </div>
          <div class="score">
            {{ 'LISTING_SYNC.PRIMARY_SOURCES.LISTING_SCORE' | translate }} {{ data.score }}/{{ data.maxScore }}
          </div>
          <glxy-badge
            class="card-badge"
            *ngIf="data.sourceHasReporting; else noReporting"
            [color]="syncStyleToBadgeColor(data.accuracyInfo?.style)"
          >
            <mat-icon inline="true" *ngIf="data.accuracyInfo?.icon">{{ data.accuracyInfo?.icon }}</mat-icon>
            <div>{{ data.accuracyInfo?.text }}</div>
          </glxy-badge>
          <glxy-badge
            *ngIf="(syncStatusloading$ | async) === false; else loadingSyncStatus"
            class="card-badge"
            [color]="syncStyleToBadgeColor(data.syncInfo?.style)"
          >
            <mat-icon *ngIf="data?.syncInfo?.icon" inline="true">{{ data?.syncInfo?.icon }}</mat-icon>
            <div>{{ data.syncInfo.text }}</div>
          </glxy-badge>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #loadingSyncStatus>
  <glxy-loading-spinner class="small-spinner" size="small"></glxy-loading-spinner>
</ng-template>

<ng-template #noReporting>
  <glxy-badge class="card-badge" color="light-grey">
    {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NO_REPORTING' | translate }}
  </glxy-badge>
</ng-template>
